import React from 'react';
import { Box, CircularProgress, Backdrop } from '@mui/material';

interface LoadingOverlayProps {
  loading: boolean;
  size?: number;
  fullScreen?: boolean;
  zIndex?: number;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  loading,
  size = 60,
  fullScreen = false,
  zIndex = 1000
}) => {
  if (!loading) return null;

  if (fullScreen) {
    return (
      <Backdrop
        open={loading}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(4px)',
          zIndex,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <CircularProgress size={size} />
      </Backdrop>
    );
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(4px)',
        zIndex,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 'inherit'
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default LoadingOverlay;
